import { render, staticRenderFns } from "./UserOptionsList.vue?vue&type=template&id=23c64d27&"
import script from "./UserOptionsList.vue?vue&type=script&lang=js&"
export * from "./UserOptionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports